import { FilterOutlined, SearchOutlined } from "@ant-design/icons";
import {
  FiltersActions, FiltersCard, FiltersCol, FiltersFieldGroup, FiltersFieldLabel,
  FiltersForm, FiltersGrid, FiltersHeader, FiltersHeaderIcon, FiltersInput, FiltersRoot,
  FiltersSelect, FiltersTitle, PrimaryFilterButton, SecondaryFilterButton,
} from "./filters.styles";

export const AlertManagementFilters = ({
  draftFilters, alertManagementOptions, solicitudTypeOptions,
  loadingAlertManagement, loadingSolicitudType,
  updateDraft, onSearch, onClear, searchDisabled,
}) => (
  <FiltersCard bordered={false}>
    <FiltersRoot>
      <FiltersHeader>
        <FiltersHeaderIcon><FilterOutlined /></FiltersHeaderIcon>
        <FiltersTitle>Filtros de búsqueda</FiltersTitle>
      </FiltersHeader>
      <FiltersForm>
        <FiltersGrid gutter={[16, 16]}>
          <FiltersCol xs={24} sm={12} lg={8}>
            <FiltersFieldGroup>
              <FiltersFieldLabel>ID encabezado</FiltersFieldLabel>
              <FiltersInput value={draftFilters.idEncabezado} type="number"
                onChange={(e) => updateDraft("idEncabezado")(e.target.value)}
                placeholder="Ingresa el ID de encabezado" allowClear />
            </FiltersFieldGroup>
          </FiltersCol>
          <FiltersCol xs={24} sm={12} lg={8}>
            <FiltersFieldGroup>
              <FiltersFieldLabel>Estado de solicitud</FiltersFieldLabel>
              <FiltersSelect value={draftFilters.estadoSolicitud} options={alertManagementOptions}
                onChange={updateDraft("estadoSolicitud")} placeholder="Selecciona un estado"
                showSearch={false} isClearable isLoading={loadingAlertManagement} />
            </FiltersFieldGroup>
          </FiltersCol>
          <FiltersCol xs={24} sm={12} lg={8}>
            <FiltersFieldGroup>
              <FiltersFieldLabel>Tipo de solicitud</FiltersFieldLabel>
              <FiltersSelect value={draftFilters.tipoSolicitud} options={solicitudTypeOptions}
                onChange={updateDraft("tipoSolicitud")} placeholder="Selecciona un tipo"
                showSearch={false} isClearable isLoading={loadingSolicitudType} />
            </FiltersFieldGroup>
          </FiltersCol>
        </FiltersGrid>
        <FiltersActions>
          <PrimaryFilterButton icon={<SearchOutlined />} onClick={onSearch} disabled={searchDisabled}>Buscar</PrimaryFilterButton>
          <SecondaryFilterButton onClick={onClear} disabled={searchDisabled}>Limpiar</SecondaryFilterButton>
        </FiltersActions>
      </FiltersForm>
    </FiltersRoot>
  </FiltersCard>
);